module.exports = __webpack_public_path__ + "static/media/templateFormBgSvg.f47e1fc6.svg";